<template>
    <form method="post" action="/register">
        <slot name="csrf-token"></slot>
        <div>
            <label for="first_name">Etunimi *</label>
            <input
                ref="first_name" v-validate="'required|min:2'" data-vv-as="Etunimi" name="first_name" id="first_name"
                placeholder="Kirjoita etunimesi tähän" class="form-control">
            <span class="error-message">{{ errors.first('first_name') }}</span>
            <br/>

            <label for="last_name">Sukunimi *</label>
            <input
                ref="last_name" v-validate="'required|min:2'" data-vv-as="Sukunimi" name="last_name" id="last_name"
                placeholder="Kirjoita sukunimesi tähän" class="form-control">
            <span class="error-message">{{ errors.first('last_name') }}</span>
            <br/>

            <label for="email">Sähköposti *</label>
            <input
                ref="email" v-validate="'required|email'" data-vv-as="Sähköposti" name="email" id="email"
                placeholder="Kirjoita sähköpostiositteesti tähän" class="form-control">
            <span class="error-message">{{ errors.first('email') }}</span>
            <br/>

            <label for="password">Salasana *</label>
            <input
                v-validate="'required|min:7'" data-vv-as="Salasana" ref="password" type="password" name="password"
                id="password" placeholder="Kirjoita salasanasi tähän" class="form-control" autocomplete="off">
            <span>{{ errors.first('password') }}</span>
            <input
                v-validate="'required|confirmed:password'" data-vv-as="Salasanan vahvistus" type="password"
                name="password_confirmation" id="password_confirmation" placeholder="Kirjoita salasana uudelleen"
                class="form-control mt-4" autocomplete="off">
            <span class="error-message">{{ errors.first('password_confirmation') }}</span>
            <br/>

            <label for="telephone">Puhelinnumero *</label>
            <input
                ref="telephone" v-validate="'required'" data-vv-as="Puhelinnumero" name="telephone" id="telephone"
                placeholder="Kirjoita puhelinnumerosi tähän" class="form-control">
            <span class="error-message">{{ errors.first('telephone') }}</span>
            <br/>

            <label class="mr-2 pt-3 pb-3" for="mies">Mies</label>
            <input
                ref="male" v-validate="'required'" data-vv-as="Sukupuoli" name="gender" type="radio" id="mies"
                value="m"/>

            <label class="mr-2 ml-4 pt-3 pb-3" for="nainen">Nainen</label>
            <input
                ref="female" name="gender" type="radio" id="nainen" value="n"/>
            <br/>

            <label for="arrival_year">Saapumisvuosi *</label>
            <select
                ref="arrival_year" v-validate="'required'" data-vv-as="Saapumisvuosi" class="form-control"
                name="arrival_year"
                :id="arrival_year">
                <option disabled selected :value="null">{{ 'Valitse saapumisvuosi' }}</option>
                <template v-for="year in this.arrival_year">
                    <option :value="year">
                        {{ year }}
                    </option>
                </template>
            </select>
            <span class="error-message">{{ errors.first('arrival_year') }}</span>

            <label for="arrival_batch">Saapumiserä *</label>
            <select
                ref="arrival_batch" v-validate="'required'" data-vv-as="Saapumiserä" class="form-control"
                name="arrival_batch"
                :id="arrival_batch">
                <option disabled selected :value="null">{{ 'Valitse saapumiserä' }}</option>
                <template v-for="batch in this.arrival_batch">
                    <option :value="batch">
                        {{ batch }}
                    </option>
                </template>
            </select>
            <span class="error-message">{{ errors.first('arrival_batch') }}</span>

            <label for="service_length">Palvelusaika *</label>
            <select
                ref="service_length" v-validate="'required'" data-vv-as="Palvelusaika" class="form-control"
                name="service_length"
                id="service_length">
                <option disabled selected :value="null">{{ 'Valitse palvelusaika' }}</option>
                <template v-for='(value, key) in this.service_length'>
                    <option :value="key">
                        {{ value }}
                    </option>
                </template>
            </select>
            <span
                class="error-message"
                v-show="errors.has('service_length')">{{ errors.first('service_length') }}</span>

            <unit-selector
                label="Valitse Yksikkö *"
                ref="unitSelector"
                validation_rule="required"
                :garrisons="this.garrisons"
                :units="this.units">
            </unit-selector>
            <span>{{ errors.first('unit') }}</span>

            <div class="flex pt-5">
            <input name="terms" type="checkbox" v-validate="'required'">
                <p class="pl-3">Olen lukenut ja hyväksyn Liikkurin <a href="/privacy">käyttöehdot</a></p>
            </div>
            <span v-show="errors.has('terms')" class="error-message">Hyväksythän käyttöehdot</span>

            <button :disabled="!isFormValid || errors.any()" type="submit" class="btn btn-primary mt-10 w-full">Rekisteröidy
            </button>

        </div>
    </form>
</template>

<script>
    import UnitSelector from "../UnitSelector";
    import Swal from 'sweetalert2'

    export default {
        name: "RegisterForm",
        components: { UnitSelector },
        props: {
            serverError: {
                type: String,
                required: false,
                default: ""
            },
            oldInput: {
                type: String,
                required: false,
                default: "",
            }
        },
        computed: {
            isFormValid() {
                return Object.keys(this.fields).every(key => this.fields[key].valid);
            },
        },
        data() {
            return {
                units: '',
                garrisons: '',
                arrival_year: '',
                arrival_batch: '',
                rank: '',
                service_length: '',
            }
        },

        created() {
            if (typeof Liikkuri !== 'undefined') {
                this.garrisons = Liikkuri.garrisons;
                this.units = Liikkuri.units;
                this.arrival_year = Liikkuri.arrival_year;
                this.arrival_batch = Liikkuri.arrival_batch;
                this.rank = Liikkuri.rank;
                this.service_length = Liikkuri.service_length;
            }

            if (this.serverError !== "") {
                Swal.fire({
                    type: 'error',
                    title: this.serverError,
                    text: 'Tarkista lomakkeen tiedot ja yritä uudelleen.',
                })
            }

            if (this.oldInput !== "" && this.oldInput) {
                const oldInputFields = JSON.parse(this.oldInput);

                this.$refs.first_name.value = oldInputFields.first_name;
                this.$refs.last_name.value = oldInputFields.last_name;
                this.$refs.email.value = oldInputFields.email;
                this.$refs.telephone.value = oldInputFields.telephone;

                if (oldInputFields.gender === 'm') {
                    this.$refs.male.checked = true
                }
                if (oldInputFields.gender === 'n') {
                    this.$refs.female.checked = true
                }

                this.$refs.arrival_year.value = parseInt(oldInputFields.arrival_year);
                this.$refs.arrival_batch.value = parseInt(oldInputFields.arrival_batch);
                this.$refs.service_length.value = oldInputFields.service_length;
            }
        }
    }
</script>

<style>

    input:valid {
        border-color: #39ad8f;
    }

    input:invalid {
        border-color: #a94442;
    }

    select:invalid {
        border-color: #a94442;
    }

    span.error-message {
        color: #a94442;
    }
</style>
